import { BlockAnalyzed } from "./block-analyzed";
/**
 * Estende BlockAnalyzed per specificare il template dell'ambito
 * Dati di esempio per l'ambito
 * [
        {
            "type": "comune",
            "name": "collebeato",
            "territorial_id": "1-03-017-017057"
        }
    ]
 */
export class BlockAnalyzedAmbito extends BlockAnalyzed {
    static override webComponentName: string = "block-analyzed-ambito";
    protected override _templateId: string = "block-analyzed-ambito";

    protected collectActualValue(): any {
        return this.value; // l'ambito non è modificabile dall'utente
    }

    protected isValidValue(value: any): boolean {
        // l'ambito è una stringa non vuota
        return Array.isArray(value) && value.length > 0;
    }
    // questo applica tutti i valori all'input target  
    protected applyValueToTarget() {
        // i valori sono i territorial_id separati da virgola 
        const el = this.targetElement;
        if (el) {
            const inputValue = (this.value as any[]).map(v => v.territorial_id).join(',');
            el.setAttribute('value', inputValue);
        }
         // se ha applicato tutti i valori disabilita tutti i bottoni 
        this.disableAllListItems();
    }
    private disableListItem(listItem: HTMLElement) {
        listItem.classList.add('disabled');
        listItem.setAttribute('aria-disabled', 'true');
        const button = listItem.querySelector('button');
        if (button) {
            button.setAttribute('tabindex', '-1');
            button.setAttribute('disabled', 'true');
        }
    }
    private disableAllListItems() {
        const listItems = this.querySelectorAll('li');
        listItems.forEach(li => {
            this.disableListItem(li as HTMLElement);
        });
    }
    // qui applica il singolo valore al target
    protected applyValue(territorial_id: string) {
        const el = this.targetElement;
        if (el) {
            //prima legge il valore attuale
            const currentValue = el.getAttribute('value') || '';
            const values = currentValue.split(',').map(v => v.trim()).filter(Boolean);
            if (!values.includes(territorial_id)) {
                values.push(territorial_id);
                el.setAttribute('value', values.join(','));
            }
        }
       
    }

    protected setupEventHandlers() {
        super.setupEventHandlers(); 
        // qui gestisce 
        this.on('click', 'button[data-id]', (e) => {
            const button = e.target as HTMLButtonElement;
            const territorial_id = button.getAttribute('data-id');
            if (territorial_id) {
                this.applyValue(territorial_id);
                // disabilita il button
                const listItem = button.closest('li');
                if (listItem) {
                    this.disableListItem(listItem as HTMLElement);
                }
            }
        });
     }
}